import Vue from 'vue'
import VueSVGIcon from 'vue-svgicon'

Vue.use(VueSVGIcon)
